import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { MySQLDateToISOPipe } from 'app/shared/mysql-date-to-iso.pipe';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';

declare const Mangler: any;

@Component({
	selector: 'modal-quote-accept',
	templateUrl: './modal-quote-accept.component.html'
})
export class ModalQuoteAcceptComponent extends UIModalBaseComponent {

	quota;
	disabled = false;
	modalTitle = '';
	subTitle = '';
	// Which of the two things this dialog is doing. It read the route to decide, which is right
	// for the quote screens and wrong everywhere else: opened from the CRM the route says `crm`,
	// so neither button rendered and the dialog had no way to finish. The caller can say instead.
	mode = 'quote';
	record = {
		id: 0,
		accepted_date: null
	};

	constructor(
		public app: AppService,
		private api: ApiService,
		private router: Router
	) {
		super();
	}

	open(data: any) {
		this.record.id = data.quoteId;
		this.record.accepted_date = null;
		this.quota = null;
		this.mode = data?.mode || this.app.routeData.module;
		this.modalTitle = 'Mark Proposal As Accepted';
		this.subTitle = 'Confirm that the customer has accepted this quote.';
		if (this.mode === 'sales-order') {
			this.modalTitle = 'Mark Sales Order as Completed';
			this.subTitle = 'Confirm that the sales order is completed';
		}
		this.api.quote.downloadQuota(this.record.id, quota => {
			this.quota = quota;
			this.record.accepted_date = MySQLDateToISOPipe.stringToDate(quota.today);
			this.modal.open();
		}, error => {
			if (error.code === 1) {
				// Cannot accept quote, pop message asking them to upgrade their account.
				const buttons = ['Close'];
				if (this.app.orgInfo.role.manage_billing) buttons.push('*Go to Billing Settings');

				this.app.dialog.pop(this.mode === 'sales-order' ? 'Finalise Sales Order' : 'Accept Quote', error.message, buttons, button => {
					if (button === 1) {
						this.router.navigate(['/' + this.app.orgInfo.alias, 'settings', 'billing']);
					}
				});
			} else {
				this.app.notifications.showDanger(error.message);
			}
		});
	}

	markAsCompletedButton() {
		this.disabled = true;

		const data = Mangler.clone(this.record);
		data.accepted_date = MySQLDateToISOPipe.dateToString(data.accepted_date);

		this.api.quote.markSalesOrderAsCompleted(data, () => {
			this.disabled = false;
			this.app.quotePriceChange.emit();
			this.app.quoteStageChange.emit('complete');
			this.modal.close(true);
		}, error => {
			this.disabled = false;
			this.app.notifications.showDanger(error.message);
		});
	}

	markAsAcceptedButton() {
		this.disabled = true;

		const data = Mangler.clone(this.record);
		data.accepted_date = MySQLDateToISOPipe.dateToString(data.accepted_date);

		this.api.quote.markAsAccepted(data, () => {
			this.disabled = false;
			this.app.quotePriceChange.emit();
			this.app.quoteStageChange.emit('accepted');
			this.modal.close(true);
		}, error => {
			this.disabled = false;
			this.app.notifications.showDanger(error.message);
		});

	}

}
